import React from 'react';

import { connect } from 'react-redux';
import classnames from 'classnames';
import { reset, reduxForm, Field } from 'redux-form';

import RenderInputField from 'shared/forms/RenderInputField';
import { required, maxLength255 } from 'shared/forms/validators';

import Button from 'shared/components/Button';

import { bookATour } from 'pages/Home/ducks';

import styles from './styles.module.scss';

const BOOK_A_TOUR_FORM_NAME = 'BookATour';

const afterSubmit = (result, dispatch) =>
  dispatch(reset(BOOK_A_TOUR_FORM_NAME));

const BookATourForm = ({
  invalid,
  submitting,
  pristine,
  bookATour,
  handleSubmit,
  submissionSuccessActions,
  submitButtonText = 'I want a Tour!'
}) => (
  <form
    className={styles.form}
    onSubmit={handleSubmit(data =>
      bookATour({
        data,
        formName: BOOK_A_TOUR_FORM_NAME,
        submissionSuccessActions
      })
    )}>
    <div className={classnames(styles.formRow, 'form-row')}>
      <div className="half-row">
        <div className="form-label">First Name*</div>
        <Field
          name="first_name"
          component={RenderInputField}
          placeholder="Enter first name"
          validate={[required, maxLength255]}
        />
      </div>
      <div className="half-row">
        <div className="form-label">Surname*</div>
        <Field
          name="surname"
          component={RenderInputField}
          placeholder="Enter surname"
          validate={[required, maxLength255]}
        />
      </div>
    </div>
    <div className={classnames(styles.formRow, 'form-row')}>
      <div className="full-row">
        <div className="form-label">Company Name*</div>
        <Field
          name="company_name"
          component={RenderInputField}
          placeholder="Enter your company name"
          validate={[required, maxLength255]}
        />
      </div>
    </div>
    <div className={classnames(styles.formRow, 'form-row')}>
      <div className="full-row">
        <div className="form-label">Contact Email*</div>
        <Field
          name="email"
          type="email"
          component={RenderInputField}
          placeholder="Enter your email address"
          validate={[required, maxLength255]}
        />
      </div>
    </div>
    <div className={classnames(styles.formRow, 'form-row')}>
      <div className="full-row">
        <div className="form-label">Contact Number*</div>
        <Field
          name="phone"
          component={RenderInputField}
          placeholder="Enter your phone number..."
          validate={[required, maxLength255]}
        />
      </div>
    </div>
    <Button
      type="submit"
      className={styles.submitBtn}
      color="primary"
      disabled={invalid || submitting || pristine}>
      {submitButtonText}
    </Button>
  </form>
);

const mapStateToProps = state => ({});

const mapDispatchToProps = { bookATour };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: BOOK_A_TOUR_FORM_NAME,
    enableReinitialize: false,
    destroyOnUnmount: true,
    onSubmitSuccess: afterSubmit
  })(BookATourForm)
);
